import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Image/index.tsx");
